export const MODULES = [
  { key: '', value: 'Todos los módulos' },
  { key: 'Dashboard', value: 'Dashboard' },
  { key: 'Emisión', value: 'Emisión' },
  { key: 'Interoperabilidad', value: 'Interoperabilidad' },
  { key: 'Reportes', value: 'Reportes' },
  { key: 'Auditoria', value: 'Auditoria' },
  { key: 'Validación de certificados', value: 'Validación de certificados' },
  { key: 'Gestión de roles', value: 'Gestión de roles' },
  { key: 'Gestión de usuarios', value: 'Gestión de usuarios' },
  { key: 'Dependencias', value: 'Dependencias' },
  { key: 'Asistente de IA', value: 'Asistente de IA' },
  { key: 'Configuración del sistema', value: 'Configuración del sistema' },
  { key: 'Configuración del certificados', value: 'Configuración del certificados' },
  { key: 'DataMart', value: 'DataMart' },
  { key: 'Consulta catastral', value: 'Consulta catastral' },
];
export const ACTIONS = [
  { key: 'Todas las acciones', value: 'Todas las acciones' },
  { key: 'Alta', value: 'Alta' },
  { key: 'Consulta', value: 'Consulta' },
  { key: 'Edición', value: 'Edición' },
  { key: 'Eliminación', value: 'Eliminación' },
  { key: 'Inicio de Sesión', value: 'Inicio de Sesión' },
  { key: 'Cierre de Sesión', value: 'Cierre de Sesión' },
];
